<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="planeFaultReport.plane_id"
          field-name="reg_num"
          source-type="planes-all"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <data-selector
          v-model="planeFaultReport.created_operator_id"
          field-name="created_operator_id"
          label="created_operator_id"
          source-type="pilots"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-if="profile.has_role.instructor"
          v-model="planeFaultReport.set_inoperable"
          :label="$t('fields.set_inoperable')"
        />
      </v-col>
      <v-col cols="12">
        {{ $t('fields.description') }}
        <v-textarea
          v-model="planeFaultReport.description"
          clearable
          autofocus
          solo
          clear-icon="mdi-close-circle"
          rows="10"
          counter
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { get } from 'vuex-pathify'

  export default {
    name: 'EditPlaneFaultReport',
    props: {
      planeFaultReport: Object,
    },
    data: function () {
      return {
      }
    },
    computed: {
      profile: get('auth/profile'),
    },
    methods: {
    },
  }
</script>
